import { useState, type FormEvent } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useSession } from '../state/session'
import { Lockup } from '../components/Brand'
import { Button, ErrorNote, Field, Spinner } from '../components/ui'

export default function LoginPage() {
  const { user, loading, signIn, settings } = useSession()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    )
  }
  if (user) return <Navigate to={user.mustChangePassword ? '/set-password' : '/'} replace />

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await signIn(email, password)
      navigate('/', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign in')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-dvh flex-col justify-center px-5 py-10">
      <div className="mx-auto w-full max-w-sm">
        <div className="mb-9">
          <Lockup orgName={settings.orgName} />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <Field label="Email">
            <input
              className="field"
              type="email"
              autoComplete="username"
              inputMode="email"
              autoCapitalize="none"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>

          <Field label="Password">
            <input
              className="field"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>

          <ErrorNote>{error}</ErrorNote>

          <Button type="submit" variant="primary" size="lg" loading={busy} className="w-full">
            Sign in
          </Button>
        </form>

        <p className="mt-8 text-center text-xs text-graphite-2">
          Lost your password? Ask the office to reset it.
        </p>
      </div>
    </div>
  )
}
